<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">ASIGNAR CIUDAD</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="txtDepartamento"
                :items="departamentos"
                item-text="departamento"
                item-value="departamento"
                label="Departamento"
                required
              ></v-autocomplete>
              <v-autocomplete
                v-model="textCiudad"
                :items="ciudad"
                item-text="ciudad"
                item-value="id"
                label="Ciudad"
                multiple
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-card-text class="text--primary px-3">
                <v-simple-table dense fixed-header>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Ciudad</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in ciudadesAsociadas" :key="item">
                        <td>{{ buscarCiudad(item) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "ModAddCiudad",
  data: () => ({
    loading: false,
    dialog: true,
    departamentos: [],
    arrayCiudad: [],
    txtDepartamento: "",
    textCiudad: [],
    ciudadesAsociadas: [],
  }),

  props: {
    id: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  computed: {
    ciudad() {
      const resul = this.arrayCiudad.filter(
        (el) => el.departamento == this.txtDepartamento
      );
      return resul;
    },
  },
  async mounted() {
    const departamentos = await db.collection("departamentos").get();
    this.departamentos = departamentos.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    const ciudad = await db.collection("ciudades").get();
    this.arrayCiudad = ciudad.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const datos = await db.collection("usuarios").doc(this.id).get();
      this.ciudadesAsociadas = datos.data().ciudades;
      this.textCiudad = this.ciudadesAsociadas;
      this.loading = false;
    },
    buscarCiudad(item) {
      if (this.arrayCiudad.some((el) => el.id == item)) {
        return this.arrayCiudad.find((el) => el.id == item).ciudad;
      }
    },
    async save() {
      this.loading = true;
      await db
        .collection("usuarios")
        .doc(this.id)
        .update({ ciudades: this.textCiudad });
      this.$swal({ icon: "success", title: "Operacion Exitosa", text: "" });
      this.loading = false;
      this.cerrarModal();
      this.$emit("actualizar");
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
